import {useContext} from 'react'
import {LocalSettingsContext} from './LocalSettingsContext.tsx'

export const useLocalSettings = () => {
  const contextInstance = useContext(LocalSettingsContext)
  if (!contextInstance) throw new Error('Cannot call useSettings() outside of <LocalSettingsProvider>')
  return contextInstance
}
